module.exports = __webpack_public_path__ + "img/arrowRight.dc550a38.svg";